import { MediaAsset } from "../types";

export const isPublicFont = (
  fontId: string,
  publicFonts: MediaAsset[] | undefined
): boolean => {
  if (!publicFonts && publicFonts?.length === 0) return false;
  const result = publicFonts?.findIndex((font) => font.id === fontId);
  return result !== -1;
};

export const validateFiles = (
  assets: {
    purpose?: string;
  }[]
) => {
  if (assets?.length === 0) {
    return true;
  }
  return !assets?.some((asset) => !asset.purpose);
};
